﻿import { epic$, store, store$ } from '@redux/store';
import loadGoogleMaps from 'libraries/mapLibrary';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { locationSearchParameters } from './constants/searchParametersConstants';
import { zoomLevelLayersLookup, zoomLevelTriggers } from './constants/sitePlansConstants';
import fetchMapResultsEpic, {
  getCommunityNearbyListingsEpic,
  getPlanNearbyListingsEpic,
  getSpecNearbyListingsEpic,
  clearNearbyListingsCarouselEpic,
  clearNearbyListingsCarouselOnMapChangesEpic,
  getBuildablePlanNearbyListingsEpic,
  updateMarkersPageNumberEpic,
  fetchSummaryCardForInteractiveSitePlanEpic,
 } from './redux/epics';

 import { mapContainerDoubleClicked$, mapContainerClicked$  } from './redux/observables';

import { mapStateSlice, interactiveSitePlanSlice } from './redux/slices';
import {
  isSearchWithinMapEnabled,
  geoCoordinates,
  isMapIdle,
  isMapLibraryFetching,
  selectSearchMapTrackingCommonProperties,
  selectedMarkerAndPage,
  isMapLibraryLoaded,
  isFetchingResults,
  selectMapLibraryStatus,
  selectedMarker,
  selectedNearbyListingCarousel,
} from './redux/selectors';
import MarkerType from './enums/markerType';


const { actions, reducer }  = mapStateSlice;
const { reducer: interactiveSitePlanReducer } = interactiveSitePlanSlice

const onMapsLibraryLoaded = () => store.dispatch(actions.mapLibraryLoaded());
const onMapsLibraryErrored = (value) => store.dispatch(actions.mapLibraryErrored(value));

epic$.next(fetchMapResultsEpic);
epic$.next(getCommunityNearbyListingsEpic);
epic$.next(getPlanNearbyListingsEpic);
epic$.next(getSpecNearbyListingsEpic);
epic$.next(getBuildablePlanNearbyListingsEpic);
epic$.next(clearNearbyListingsCarouselEpic);
epic$.next(updateMarkersPageNumberEpic);
epic$.next(clearNearbyListingsCarouselOnMapChangesEpic);
epic$.next(fetchSummaryCardForInteractiveSitePlanEpic);

store.injectReducer('mapState', reducer);
store.injectReducer('interactiveSitePlanState', interactiveSitePlanReducer)

store$
  .pipe(map(isMapLibraryFetching), distinctUntilChanged(), filter(Boolean))
  .subscribe(() => loadGoogleMaps(onMapsLibraryLoaded, onMapsLibraryErrored));

export const createMap = () => store.dispatch(mapStateSlice.actions.mapLibraryFetch());
export const getGeoCoordinates = () => geoCoordinates(store.getState());
export {
  fetchMapResultsEpic,
  actions as mapStateActions,
  reducer as mapStateReducers,
  locationSearchParameters,
  isSearchWithinMapEnabled,
  isMapIdle,
  geoCoordinates,
  selectMapLibraryStatus,
  selectSearchMapTrackingCommonProperties,
  isMapLibraryLoaded,
  isFetchingResults as isMapResultsFetching,
  selectedMarker,
  selectedNearbyListingCarousel,
  MarkerType,
  selectedMarkerAndPage,
  mapContainerDoubleClicked$,
  mapContainerClicked$,
  zoomLevelLayersLookup,
  zoomLevelTriggers,
};

require('./components/map');
require('./components/marker');
require('./components/nearbyListingsCarousel');
require('./components/sitePlansHandler');
require('./components/interactiveSitePlansHandler');
require('./analytics/searchWithinMap');
require('./components/boundaries');
require('./components/markerSessionHandler');
require('./components/lotSummaryCard');